<template>
	<el-container class="home">
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;">
				<s-header-top></s-header-top>
			</el-header>

			<el-header class="header">
				<div class="content">
					<el-row type="flex" justify="space-around" align="middle" style="height: 90px;">
						<el-col :span="10"  style="display: flex;align-items: center;flex-direction: row;">
							<div style="display: flex;align-items: center;margin-right: 10px;"><el-image style="width: 70px; height: 70px" :src="require('../../static/logo.png')" fit="scale-down"></el-image></div>
							<div >
								<div class="mediue-font">襄阳人才双创大数据平台</div>
							</div>
						</el-col>
						<el-col :span="8">
							<el-input placeholder="请输入内容" v-model="keyWord" class="input-with-select" @keyup.enter.native="handleSearch()">
								<el-select v-model="selectType" slot="prepend" placeholder="请选择">
									<el-option v-for="(item, index) in selectArr" :key="index" :label="item.name" :value="item.path"></el-option>
								</el-select>
								<el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
							</el-input>
						</el-col>
						<el-col :span="6">
							<el-row type="flex" justify="end">
								<el-button type="primary" size="medium" @click="handleRelease()">免费发布需求</el-button>
								<!-- <el-button type="warning" size="medium">免费找官方推荐</el-button> -->
							</el-row>
						</el-col>
					</el-row>
				</div>
			</el-header>

			<el-main>
				<div class="content">
					<el-row :gutter="20">
						<el-col :span="8">
							<el-row class="notice">
								<el-row class="noticeTitle" type="flex" align="middle">
									<el-col :span="16" class="titleName">通知公告</el-col>
									<el-col :span="8" class="more"><div @click="goNotice">更多></div></el-col>
								</el-row>
								<div style="height: 310px;overflow: hidden;">
									<el-row v-for="(item, index) in noticeList" :key="index" style="margin-top: 15px;cursor: pointer;">
										<el-col :span="2"><div class="sm-circle"></div></el-col>
										<el-col :span="22">
											<div class="notice-title" @click="goNoticeDetail(item)">{{ item.title }}</div>
										</el-col>
									</el-row>
								</div>
							</el-row>
						</el-col>
						<el-col :span="16">
							<div class="banner" style="position: relative;">
								<el-carousel height="400px" :interval="3000" ref="carousel">
									<el-carousel-item v-for="(item, index) in bannerList" :key="index" :label="item.title">
										<el-image class="bannerImg" @click="goHref(item.href)" fit="cover" :src="item.image ? imgPath(item.image) : require('../../static/banner.png')" ></el-image>
									</el-carousel-item>
								</el-carousel>
							</div>
						</el-col>
					</el-row>
					<div class="menuItem">
						<!-- 双创政策 -->
						<div class="item">
							<router-link :to="`/policy`" target="_blank"  tag="a">
								<div class="itemCircle" :style="{ backgroundImage: 'url(' + require('../../static/policy.png') + ')' }"></div>
								<div class="itemName">双创政策</div>
							</router-link>
						</div>
						<!-- 载体平台 -->
						<div class="item">
							<router-link :to="`/supporter`" target="_blank"  tag="a">
								<div class="itemCircle" :style="{ backgroundImage: 'url(' + require('../../static/supporter.png') + ')' }"></div>
								<div class="itemName">载体平台</div>
							</router-link>
						</div>
						<!-- 服务产品 -->
						<div class="item">
							<router-link :to="`/product`" target="_blank"  tag="a">
								<div class="itemCircle" :style="{ backgroundImage: 'url(' + require('../../static/product.png') + ')' }"></div>
								<div class="itemName">服务产品</div>
							</router-link>
						</div>
						<!-- 专家导师 -->
						<div class="item">
							<router-link :to="`/expert`" target="_blank"  tag="a">
								<div class="itemCircle" :style="{ backgroundImage: 'url(' + require('../../static/expert.png') + ')' }"></div>
								<div class="itemName">专家导师</div>
							</router-link>
						</div>
						<!-- 服务机构 -->
						<div class="item">
							<router-link :to="`/person`" target="_blank"  tag="a">
								<div class="itemCircle" :style="{ backgroundImage: 'url(' + require('../../static/person.png') + ')' }"></div>
								<div class="itemName">服务机构</div>
							</router-link>
						</div>
						<!-- 双创项目 -->
						<div class="item">
							<router-link :to="`/project`" target="_blank"  tag="a">
								<div class="itemCircle" :style="{ backgroundImage: 'url(' + require('../../static/project.png') + ')' }"></div>
								<div class="itemName">双创项目</div>
							</router-link>
						</div>
						<!-- 技术成果 -->
						<div class="item">
							<router-link :to="`/achievement`" target="_blank"  tag="a">
								<div class="itemCircle" :style="{ backgroundImage: 'url(' + require('../../static/achievement.png') + ')' }"></div>
								<div class="itemName">技术成果</div>
							</router-link>
						</div>
						<!-- 9-25号之后金融创投 -->
						<div class="item">
							<router-link :to="`/carrier`" target="_blank"  tag="a">
								<div class="itemCircle" :style="{ backgroundImage: 'url(' + require('../../static/carrier.png') + ')' }"></div>
								<div class="itemName">金融创投</div>
							</router-link>
						</div>
						<!-- 双创活动 -->
						<div class="item">
							<router-link :to="`/activity`" target="_blank"  tag="a">
								<div class="itemCircle" :style="{ backgroundImage: 'url(' + require('../../static/activity.png') + ')' }"></div>
								<div class="itemName">双创活动</div>
							</router-link>
						</div>
					</div>
					<el-row :gutter="10">
						<el-col :span="12" v-for="(item, index) in linkPicList" :key="index">
							<div class="pro" :style="{ backgroundImage: 'url(\'' + $imgBaseUrl + item.image + '\')' }">
								<el-row>
									<div class="proName" @click="goHref(item.href)">{{ item.title }}</div>
								</el-row>
								<el-row>
									<div class="proArea">{{ item.remarks }}</div>
								</el-row>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-main>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeaderTop from '@/components/header_top';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import Pagination from '@/components/Pagination'
import { loginout, bannerList, linkPicList, noticeList, wxAuthorization } from '@/api';
import store from '@/store/index.js';
export default {
	name: 'index',
	components: {
		sHeaderTop,
		sFooter,
		sCopyRight
	},
	data() {
		return {
			selectArr: [
				{
					id: 'msg_policy_1',
					name: '公告',
					path: '/notice'
				},
				{
					id: 'msg_platformEvents',
					name: '平台大事',
					path: '/platformEvents'
				},
				{
					id: 'msg_platform',
					name: '载体平台',
					path: '/supporter'
				},
				{
					id: 'msg_policy_0',
					name: '双创政策',
					path: '/policy'
				},
				{
					id: 'msg_product',
					name: '服务产品',
					path: '/product'
				},
				{
					id: 'msg_expert',
					name: '专家导师',
					path: '/expert'
				},
				{
					id: 'msg_hight_talents',
					name: '高层次人才',
					path: '/person'
				},
				{
					id: 'msg_project',
					name: '双创项目',
					path: '/project'
				},
				{
					id: 'msg_achievements',
					name: '技术成果',
					path: '/achievement'
				},
				{
					id: 'msg_carrier',
					name: '金融创投',
					path: '/carrier'
				},
				{
					id: 'msg_activity',
					name: '双创活动',
					path: '/activity'
				}
			],
			selectType: '',//搜索类型
			keyWord: '', //搜索关键字
			noticeList: [], //通知公告列表
			bannerList: [], //banner图
			linkPicList: [], //底部两大图片

		};
	},
	mounted() {
		let _this = this;
		this.getNoticeList();
		this.getBannerList();
		this.getLinkPicList();
	},
	methods: {
		//去登陆
		toWxAuthorization(){
			window.location.href ="https://open.weixin.qq.com/connect/qrconnect?appid=wx8683c33354eeddb1&redirect_uri=https://xyqyfw.com/sovo&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect"
		},
		//去注册
		goRegister() {
			let routeUrl = this.$router.resolve({
				path: '/register'
			});
			window.open(routeUrl.href, '_blank');
		},
		//搜索
		handleSearch(){
			let _this = this
			if(_this.selectType == ''){
				this.$message({
				  message: '请选择搜索范围',
				  type: 'warning'
				});
				return false;
			}
			if(_this.keyWord == ''){
				this.$message({
				  message: '请输入搜索关键字',
				  type: 'warning'
				});
				return false;
			}
			let routeUrl = this.$router.resolve({
				path: _this.selectType,
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					keyWord: _this.keyWord
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		//免费发布需求
		handleRelease(){
			//如果当前未登录提示先登录
			if(store.state.isLogin){
				this.$router.push({ path: '/release' });
			}else{
				this.$confirm('发布需求需要先登录, 是否登录?', '提示', {
					confirmButtonText: '去登陆',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					this.toWxAuthorization()
				})
				.catch(() => {});
			}
		},
		//点击通知公告 更多跳转至通知公告列表
		goNotice() {
			let routeUrl = this.$router.resolve({
				path: '/notice'
			});
			window.open(routeUrl.href, '_blank');
		},
		//点击具体通知 跳转至 通知公告详情
		goNoticeDetail(item) {
			let routeUrl = this.$router.resolve({
				path: '/noticeDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: item.id
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		//获取banner图片
		getBannerList() {
			bannerList().then(res => {
				this.bannerList = res.data;
			});
		},
		//获取 底部两个大图片数据
		getLinkPicList() {
			linkPicList().then(res => {
				this.linkPicList = res.data;
			});
		},
		//获取通知公告前10条
		getNoticeList() {
			noticeList({
				pageNo: '1',
				pageSize: '10'
			}).then(res => {
				this.noticeList = res.data.list;
			});
		},
		//图片请求地址
		imgPath(oldPath) {
			return this.$imgBaseUrl + oldPath;
		},
		//超链接跳转第三方网站
		goHref(url) {
			window.open(url, '_blank');
		}
	}
};
</script>

<style lang="scss" scoped>
/*main*/
.notice,
.banner {
	height: 400px;
}
.notice {
	background-image: url(../../static/notice.jpg);
	background-repeat: no-repeat;
	background-position: center center;
	background-size: cover;
	padding: 25px 35px;
	color: #ffffff;
}
.noticeTitle {
	height: 38px;
	letter-spacing: 1px;
	color: #ffffff;
}
.titleName {
	font-size: 24px;
}
.more {
	text-align: right;
	cursor: pointer;
	font-size: 14px;
}
.sm-circle {
	margin-top: 6px;
	width: 8px;
	height: 8px;
	border-radius: 4px;
	background-color: #267ce4;
}
.notice-title {
	font-size: 14px;
	line-height: 24px;
	color: #dddddd;
	text-overflow: -o-ellipsis-lastline;
	letter-spacing: 1px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

.bannerImg {
	height: 100%;
	width: 100%;
	cursor: pointer;
}
/*menu*/
.menuItem {
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin-top: 20px;
	margin-bottom: 20px;
	background-color: #fff;
	box-shadow: 0px 2px 7px 0px #a5a4a4;
}
.item {
	flex: 0 0 calc(100% / 9);
}
.item a {
	text-decoration: none;
	color: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.itemCircle {
	width: 80px;
	height: 80px;
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 80px 80px;
}
.itemName {
	font-size: 17px;
	font-weight: bold;
	color: #4A99DD;
	text-align: center;
	margin-bottom: 18px;
}
/*project*/
.pro {
	height: 180px;
	box-sizing: border-box;
	background-repeat: no-repeat;
	background-position: center center;
	background-size: cover;
	padding: 8px 25px 0px 25px;
	color: #ffffff;
}
.proName {
	font-size: 40px;
	letter-spacing: 2px;
	line-height: 76px;
	height: 76px;
	color: #ffffff;

	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: pointer;
}
.proArea {
	font-size: 20px;
	letter-spacing: 1px;
	line-height: 30px;
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.notice,
.banner,
.pro {
	box-shadow: 0px 6px 6px 0px #a5a4a4;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue